if (!customElements.get('custom-popup-notes')) {
  customElements.define('custom-popup-notes', class CustomPopupNotes extends Popup {
    constructor()
    {
      super();

      this.onBroadcast('wishlisted', data => {
        this.open(data.product_id.split('/')[4], true);
      });
    }

    open(donorId, isFromWishlist = false)
    {
      super.open();

      this.donorId = donorId;
      this.update();

      this.querySelector('[name="note"]').value = '';
      this.querySelector('.popup-note-error').classList.add('hidden');
      this.classList.toggle('is-wishlist', isFromWishlist);

      this.submit = this.querySelector('.popup-note-submit');
      this.submit.addEventListener('click', e => {
        e.preventDefault();

        if (this.submit.classList.contains('loading')) {
          return;
        }

        this.submit.classList.add('loading');
        this.querySelector('.popup-note-error').classList.add('hidden');

        app.notes.update(this.donorId, this.querySelector('[name="note"]').value.trim())
          .then(() => this.close())
          .catch(err => this.querySelector('.popup-note-error').classList.remove('hidden') && console.error(err))
          .finally(() => this.submit.classList.remove('loading'));
      });

      this.querySelector('.popup-note-close').addEventListener('click', e => {
        e.preventDefault();

        this.close();
      });
    }

    update()
    {
      app.notes.getNoteByProductId(this.donorId)
        .then(data => {
          this.querySelector('[name="note"]').value = data?.note || '';
        });
    }
  });
}